// fieldTooltip — the single resolver for a field's admin-set help tooltip,
// shared by AddFormV1 and EditFormV1.
//
// Two config shapes exist and both are honoured:
//   • `field.tooltip`                     (NEW key — one string, always shown)
//   • `field.infoEnabled` + `field.infoText`  (the original toggle + text pair)
//
// Before this, tooltip text only ever reached the screen through FieldLabel, so
// a field rendered WITHOUT a label (an inline/combined box, or a group that
// prints one shared header row) could never carry one. Both forms now fall back
// to wrapping the control itself for those, so ANY control type can get an
// admin-set tooltip — which is the whole point: the text is config, the
// capability is code.

const blank = (v) => v === undefined || v === null || String(v).trim() === '';
const truthy = (v) => v === true || v === 1 || v === '1' || v === 'true';

/** @returns {string} the tooltip text for a field, or '' when it has none. */
export function fieldTooltipText(field) {
  if (!blank(field?.tooltip)) return String(field.tooltip);
  if (truthy(field?.infoEnabled) && !blank(field?.infoText)) return String(field.infoText);
  return '';
}

export default { fieldTooltipText };
